var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "logs" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "navy headline" },
                [
                  _c("span", { staticClass: "white--text" }, [
                    _vm._v("Registro Eventi"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", light: "", icon: "" },
                      on: { click: _vm.dismiss },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _vm.astaLogs && _vm._.size(_vm.astaLogs) > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "v-list",
                        {
                          staticClass: "overflow-y-auto mr-1 pr-1",
                          class: { "nice-scroll": !_vm.is_mobile },
                          attrs: { dense: "", "max-height": "450px" },
                        },
                        _vm._l(_vm.astaLogs, function (log) {
                          return _c(
                            "v-list-item",
                            { key: log.key },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("asta-log", {
                                    attrs: { small: "", log: log },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-action",
                                { staticClass: "timestamp" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(log.tsFormatted) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "lista-vuota py-4" }, [
                    _vm._v("Nessun evento."),
                  ]),
              _vm._v(" "),
              !_vm.loadingLogs &&
              !_vm.noMoreLogs &&
              _vm.astaLogs &&
              _vm._.size(_vm.astaLogs) > 0
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex justify-center",
                      staticStyle: { height: "50px" },
                    },
                    [
                      _c(
                        "v-btn",
                        { attrs: { icon: "" }, on: { click: _vm.loadMore } },
                        [
                          _c("v-icon", { staticClass: "navy--text" }, [
                            _vm._v("expand_more"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loadingLogs
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex justify-center",
                      staticStyle: { height: "50px" },
                    },
                    [
                      _c("v-progress-circular", {
                        staticClass: "navy--text",
                        attrs: { indeterminate: "" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }